<template>
  <div id="app">
    <Header />
    <router-view />

    <b-alert
        v-if="show"
        :variant="variant"
        dismissible
        class="position-fixed bottom-0 end-0 m-3"
        style="z-index: 9999"
        @dismissed="clearNotification"
    >
      {{ message }}
    </b-alert>
  </div>
</template>

<script>
import Header from "./components/HeaderComponent.vue";

export default {
  name: "App",
  components: { Header },
  setup() {  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

html, body {
  height: 100%;
  overscroll-behavior-y: none; /* bloque le pull-to-refresh + le scroll chaining */
}
</style>
